import { FALLBACK_REGION_CODE } from '@connect-x-app/shared-translations';
import { parsePhoneNumber } from 'awesome-phonenumber';
import LinkifyIt, { Match } from 'linkify-it';
import tlds from 'tlds';

const linkify = new LinkifyIt();
linkify.tlds(tlds);

// A candidate is just a digit run with phone-style separators: parsePhoneNumber() below decides
// whether it is actually a number, so this only has to be shaped roughly right. Keeping the
// pattern this loose is what keeps it readable (Sonar S5843).
const PHONE_NUMBER_REGEX = /\+?\(?\d[\d\s\-./()]+\d/g;

export const getLinkMatches = (text: string, regionCode: string = FALLBACK_REGION_CODE): Match[] => {
  const defaultMatches = linkify.match(text) ?? [];

  // matchAll (not match + indexOf) so a number repeated in one message reports the index of each
  // occurrence rather than the first one every time.
  const phoneNumberMatches = [...text.matchAll(PHONE_NUMBER_REGEX)]
    .map(match => {
      const phoneNumber = parsePhoneNumber(match[0], { regionCode });
      if (phoneNumber?.valid) {
        return {
          index: match.index,
          lastIndex: match.index + match[0].length,
          raw: match[0],
          schema: 'tel:',
          text: match[0],
          url: `tel:${phoneNumber.number.e164}`,
        };
      }
      return null;
    })
    // We can cast as Match[] here since the filter(Boolean) leaves out the null ones
    .filter(Boolean) as Match[];

  return [...phoneNumberMatches, ...defaultMatches].sort((a, b) => a.index - b.index);
};
